import { useContext, useEffect, useCallback, useState } from 'react'
import styled from '@emotion/styled'
import DownloadIcon from '@mui/icons-material/GetApp'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import {
  EnhancedTable,
  CvsDateRangeToolbar,
  CvsPaginationFooter,
  CvsNoCheckmarkHeader,
  CvsNoCheckboxRow,
} from '@components'
import { colors } from '@global/constants'
import { reportContext } from '@contexts'
import { t } from '@lingui/core/macro'

const FlexSpaceBetween = styled.div`
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
`

const today = moment().endOf(1, 'day').format('YYYY-MM-DD')

const threeMonthsAgo = moment().subtract(3, 'months').format('YYYY-MM-DD')

export const UsageReport = () => {
  const { fetchSubmissionsReport, submissions, downloadReport } = useContext(reportContext)
  const history = useHistory()
  const [range, setRange] = useState({ startDate: threeMonthsAgo, endDate: today })

  useEffect(() => {
    fetchSubmissionsReport(range.startDate || threeMonthsAgo, range.endDate || today)
  }, [fetchSubmissionsReport, range])

  const filterByDate = useCallback(
    ({ startDate, endDate }) => {
      if (
        startDate.format('YYYY-MM-DD') !== range.startDate ||
        endDate.format('YYYY-MM-DD') !== range.endDate
      ) {
        setRange({
          startDate: startDate.format('YYYY-MM-DD'),
          endDate: endDate.format('YYYY-MM-DD'),
        })
        return []
      }
      return submissions
    },
    [range],
  )

  return (
    <>
      <FlexSpaceBetween>
        <div style={{ paddingTop: 12 }}>
          <div
            style={{
              height: '60px',
              width: '140px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h6" style={{ paddingTop: '15px', paddingLeft: '28px' }}>
              {t`Usage report`}
            </Typography>
          </div>
        </div>
        <div style={{ padding: '28px 12px 12px 12px' }}>
          <Button
            name="usage-report-download"
            color="secondary"
            onClick={() => downloadReport('usage', range)}
            style={{
              color: colors.white,
              padding: '5px 0px 5px 7px',
              // display: 'contents',
              // justifyContent: 'center',
            }}
            variant="contained"
            startIcon={<DownloadIcon />}
          />
        </div>
      </FlexSpaceBetween>
      <EnhancedTable
        blockMultipleEdit
        keyField="dataset_id"
        orderBy="name"
        order="asc"
        ToolbarComponent={CvsDateRangeToolbar}
        FooterComponent={CvsPaginationFooter}
        HeaderComponent={CvsNoCheckmarkHeader}
        RowComponent={CvsNoCheckboxRow}
        onFilterChange={filterByDate}
        columns={[
          { label: t`Template`, width: '20%', lookup: 'template_name' },
          { label: t`Submission`, width: '20%', lookup: 'submission_name' },
          {
            label: t`Submitter`,
            width: '20%',
            lookup: 'submitter_name',
          },
          {
            label: t`Rows`,
            width: '20%',
            lookup: 'number_of_codes',
            type: 'number',
          },
          { label: t`Created`, width: '20%', type: 'date', lookup: 'created_at' },
        ]}
        handleRowClick={id => history.push(`/codes/details/${id}/data`)}
        rows={submissions}
        noAdd
      />
    </>
  )
}
